import Card from "@/components/Card";
import PageHeader from "@/components/PageHeader";

export default function Settings() {
  return (
    <div className="space-y-6">
      <PageHeader title="Settings" subtitle="Installation configuration. Read-only in this release." />
      <Card title="Identity provider (OIDC)">
        <div className="text-sm text-text-secondary">
          Customer-configured IdP details appear here.
        </div>
      </Card>
    </div>
  );
}
